import React from "react";
import ResetForm from "./ResetForm";
import { Actions } from "../../../core/modules/Actions";

const ResetDeviceIdForm = ({ onclickcancel = () => {} }) => {
  return (
    <ResetForm
      onclickcancel={onclickcancel}
      title="Reset Students' Device Id"
      buttonText="Reset Device Id"
      placeholder="Enter student email address"
      onSubmitAction={Actions.common.resetDeviceId}
    />
  );
};

export default ResetDeviceIdForm;
